@if (nonEmptyErrors?.length) {
<div>
  @if (nonEmptyErrors?.length === 1) {
  <div>
    <div [className]="promptClassError">
      <div [className]="iconBackgroundError">
        <img src="assets/images/warning.svg" class="error-red" />
      </div>
      <div class="message">{{ nonEmptyErrors[0] }}</div>
    </div>
  </div>
  } @if (nonEmptyErrors?.length > 1) {
  <div>
    <div [className]="promptClassError" id="multi-messages">
      <div [className]="iconBackgroundError">
        <img src="assets/images/warning.svg" class="error-red" />
      </div>
      <ul class="message multiple-messages">
        @for (msg of nonEmptyErrors; track msg) {
        <li>{{ msg }}</li>
        }
      </ul>
    </div>
  </div>
  }
</div>
} @if (warnings?.length) {
<div>
  @if (warnings?.length === 1) {
  <div>
    <div [className]="promptClassWarning">
      <div [className]="iconBackgroundWarning">
        <img src="assets/images/warning.svg" class="warn-yellow" />
      </div>
      <div class="message">{{ warnings[0] }}</div>
    </div>
  </div>
  } @if (warnings?.length > 1) {
  <div>
    <div [className]="promptClassWarning" id="multi-messages">
      <div [className]="iconBackgroundWarning">
        <img src="assets/images/warning.svg" class="warn-yellow" />
      </div>
      <ul class="message multiple-messages">
        @for (msg of warnings; track msg) {
        <li>{{ msg }}</li>
        }
      </ul>
    </div>
  </div>
  }
</div>
}
